import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";

const Warranties = () => (
  <StyledWarranties>
    <Container>
      <UnderlinedHeader text={"Gwarancja"} bolder />
      <ol>
        <li>
          <p>Każda sprzedaż towaru podlega standardowej gwarancji.</p>
          <p>
            Pedders gwarantuje jakość wszystkich produktów dystrybuowanych przez
            Pedders oraz pod marką Pedders przez okres dwudziestu czterech (24)
            miesięcy od daty wystawienia faktury lub do czasu, gdy pojazd w
            którym zamontowane zostały ww. produkty przejechał 40 000 kilometrów
            od daty montażu przedmiotowych towarów, w zależności od tego, co
            nastąpi wcześniej.
          </p>
          <p>
            Jeśli podczas procesu reklamacyjnego zostanie potwierdzone przez
            przedstawiciela Pedders jakakolwiek wada pod względem materiału lub
            wykonania towaru dostarczonego przez Pedders i jeśli towar nie
            został uszkodzony w wyniku niewłaściwego użytkowania, niewłaściwej
            instalacji lub obsługi, braku konserwacji lub innej przyczyny
            wynikającej z niewłaściwego użytkowania, towar zostanie wymieniony
            lub naprawiony przez Pedders. Koszt demontażu i / lub montażu
            towarów nie jest objęty gwarancją standardową.
          </p>
          <p>
            Pedders nie ponosi odpowiedzialności za jakiekolwiek szkody
            spowodowane w towarze w jakimkolwiek pojeździe lub innym
            komponencie, jeśli według ekspertyzy Pedders, towary zostały
            nieprawidłowo zamontowane przez Nabywcę lub zostały użyte do celu,
            dla którego nie zostały wyprodukowane.
          </p>
        </li>
        <li>
          <p>
            Wszystkie zasady uwzględnione w warunkach gwarancji oraz określone
            ustawą wykluczają wszelką odpowiedzialność za straty lub szkody
            wynikające z zaniedbania lub z jakiejkolwiek innej przyczyny leżącej
            po stronie użytkownika.
          </p>
        </li>
        <a
          href={"https://ozparts.eu/warranty/PEDDERS_PL/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <StyledButton>Formularz gwarancyjny</StyledButton>
        </a>
      </ol>
    </Container>
  </StyledWarranties>
);

export default Warranties;

const StyledWarranties = styled.section`
  padding-top: 92px;
  color: #666666;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
`;

const StyledButton = styled.button`
  border: none;
  padding: 10px;
  border-radius: 4px;
  color: #fff;
  background-color: #dc3332;
  font-size: 14px;
  font-weight: 600;
  margin: 20px 0;
  font-family: "Open Sans", sans-serif;
`;
